import { Component, inject } from "@angular/core";
import { CardModalService } from "@shared/card-modal";
import { SharedModule } from "@shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

@Component({
    selector: "wk-panel-icon-users",
    imports: [TranslateModule, JumpstartComponentsModule, SharedModule],
    templateUrl: "./panel-icon-users.component.html",
    styleUrl: "./panel-icon-users.component.scss",
    host: { class: "wk-cm__header__icon wk-cm__header__icon-users" },
})
export class PanelIconUsersComponent {
    public readonly cardModalService = inject(CardModalService);
}
